<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>{{ blog?.title }}</h2>
            <ul>
                <li>
                    <a routerLink="/">Home</a>
                </li>
                <li>
                    <a routerLink="/blog">Blog</a>
                </li>
                <li>
                    {{ blog?.category }}
                </li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Blog Details Area -->
<section class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <!-- ================= MAIN CONTENT ================= -->
            <div class="col-lg-8 col-md-12">
                <div class="blog-details-desc">
                    <!-- Featured Image -->
                    <div class="blog-details-image">
                        <img [src]="blog?.image" [alt]="blog?.title" />
                    </div>

                    <!-- Blog Meta -->
                    <div class="blog-details-meta">
                        <span>
                            <i class="bx bx-book-open"></i>
                            {{ blog?.category }}
                        </span>

                        <span>
                            <i class="bx bx-calendar"></i>
                            {{ blog?.date }}
                        </span>
                    </div>

                    <!-- Blog Title -->
                    <h1>
                        {{ blog?.title }}
                    </h1>

                    <!-- Introduction -->
                    <div *ngFor="let paragraph of blog?.intro">
                        <p class="lead">
                            {{ paragraph }}
                        </p>
                    </div>

                    <!-- ================= DYNAMIC SECTIONS ================= -->

                    <ng-container *ngFor="let section of blog?.sections">
                        <!-- Section Heading -->
                        <h2>
                            {{ section.title }}
                        </h2>

                        <!-- Section Paragraphs -->
                        <p *ngFor="let paragraph of section.paragraphs">
                            {{ paragraph }}
                        </p>

                        <!-- ================= STEPS ================= -->

                        <div class="blog-process-item" *ngFor="let step of section.steps">
                            <div class="process-number">
                                {{ step.number }}
                            </div>

                            <div class="process-content">
                                <h3>
                                    {{ step.title }}
                                </h3>

                                <p>
                                    {{ step.description }}
                                </p>
                            </div>
                        </div>
                    </ng-container>

                    <!-- ================= BENEFITS ================= -->

                    <ng-container *ngIf="blog?.benefits?.length">
                        <h2>Benefits of Solar</h2>

                        <ul class="blog-benefits-list">
                            <li *ngFor="let benefit of blog.benefits">
                                <i class="bx bx-check-circle"></i>

                                <span>
                                    {{ benefit }}
                                </span>
                            </li>
                        </ul>
                    </ng-container>

                    <!-- ================= CTA ================= -->

                    <div class="blog-details-cta" *ngIf="blog?.cta">
                        <div>
                            <span> Ready to explore solar? </span>

                            <h3>
                                {{ blog.cta.title }}
                            </h3>
                        </div>

                        <a [routerLink]="blog.cta.link" class="btn btn-primary">
                            {{ blog.cta.buttonText }}

                            <i class="flaticon-right"></i>
                        </a>
                    </div>
                </div>
            </div>

            <!-- ================= SIDEBAR ================= -->

            <div class="col-lg-4 col-md-12">
                <div class="blog-sidebar">
                    <!-- Solar Solutions -->
                    <div class="sidebar-widget">
                        <h3>Solar Solutions</h3>
                        <ul>
                            <li>
                                <a routerLink="/on-grid">
                                    On-Grid Solar
                                    <i class="bx bx-right-arrow-alt"></i>
                                </a>
                            </li>
                            <li>
                                <a routerLink="/off-grid">
                                    Off-Grid Solar
                                    <i class="bx bx-right-arrow-alt"></i>
                                </a>
                            </li>
                            <li>
                                <a routerLink="/hybrid">
                                    Hybrid Solar
                                    <i class="bx bx-right-arrow-alt"></i>
                                </a>
                            </li>
                            <!-- <li>
                                <a routerLink="/solar-calculator">
                                    Solar Calculator

                                    <i class="bx bx-right-arrow-alt"></i>
                                </a>
                            </li> -->
                        </ul>
                    </div>

                    <!-- Need Help -->
                    <div class="sidebar-widget solar-help-widget">
                        <div class="icon">
                            <i class="bx bx-sun"></i>
                        </div>
                        <span> Need Help? </span>
                        <h3>Not sure which solar system is right for you?</h3>
                        <a routerLink="/contact" class="btn btn-primary">
                            Talk to Our Experts
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Blog Details Area -->